import { useI18n } from '@cascade/react/i18n';
import { Link, Text } from '@cascade/ui-library';
import { company } from '@cascade/core/constants';

export const SupportContact = () => {
  const { translate } = useI18n();
  const { supportEmail } = company;

  const email = (
    <Link
      label={supportEmail}
      uri={`mailto:${supportEmail}`}
      target='self'
      textProps={{ type: 'caption' }}
    />
  );

  return (
    <Text
      type='caption'
      color='text-60'
      content={translate('support.prompt', { email })}
    />
  );
};
